module.exports = __webpack_public_path__ + "img/ciic.57272d46.png";